import AttendeeType from 'owa-service/lib/contract/AttendeeType';
import attendeeType from 'owa-service/lib/factory/attendeeType';
import { orchestrator } from 'satcheljs';
import {
    updateResources,
    updateLocations,
    onLocationsChanged,
} from 'owa-calendar-compose-form-actions';
import { isRoom, getRoomEmailFromLocation } from 'owa-location-persona';
import { updateMailtips } from 'owa-mail-tips';
import getCurrentEventOrganizer from 'owa-calendar-compose-form-store/lib/selectors/getCurrentEventOrganizer';
import getFromAddress from '../utils/getFromAddress';

export default orchestrator(updateLocations, actionMessage => {
    const { locations } = actionMessage;
    // Locations can be empty
    if (!locations) {
        onLocationsChanged([]);
        updateResources([]);
    } else {
        onLocationsChanged(locations);

        // Set resources collection
        let resources: AttendeeType[] = [];
        let resourceEmailAddress: string[] = [];
        locations.forEach(location => {
            if (location && isRoom(location.PostalAddress)) {
                resources.push(
                    attendeeType({
                        Mailbox: getRoomEmailFromLocation(location),
                    })
                );
                resourceEmailAddress.push(location.PostalAddress.LocationUri);
            }
        });

        updateResources(resources);

        if (resourceEmailAddress.length > 0) {
            const organizer = getCurrentEventOrganizer();
            const fromEmailAddress: string = getFromAddress(organizer);
            updateMailtips(null, fromEmailAddress, resourceEmailAddress);
        }
    }
});
